import { TAnimatedDropdown } from "../../../Types";
import { useTransition, animated } from "react-spring";
import SubMenuDropDown from "./SubMenuDropDown";
import React from "react";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";

const AnimatedDropdown = withLiteObserverAndTheme<TAnimatedDropdown>(
  (props) => {
    const { options, isMenuOpen } = props;
    const transitions = useTransition(isMenuOpen, null, {
      from: { opacity: 1 },
      enter: { opacity: 1 },
      leave: { opacity: 0 },
      config: { duration: 200, delay: 100 }
    });

    return (
      <React.Fragment>
        {transitions.map(
          ({ item, key, props }) =>
            item && (
              <animated.div key={key} style={props}>
                <SubMenuDropDown options={options} />
              </animated.div>
            )
        )}
      </React.Fragment>
    );
  }
);
export default AnimatedDropdown;
